<template>
    <div class="detailed-list-history detailed-list ">
        <div class="header-title">
            <div class="name-input">
                历史报价
            </div>
        </div>
        <div class="content">
            <div>
                <span class="gotoPrev" @click="gotoPrev">
                    <i class="iconfont icon-arrow-right"></i>
                </span>
                <button class="text-btn" @click="reductionAll">全部还原</button>
            </div>
            <div class="clr"></div>
            <div class="card-list">
                <div class="item" v-for="(item,index) in historyList" :key="index">
                    <div v-if="item.product">
                        <div class="left-info">
                            <div class="product-img">
                                <img :src="imgBaseUrl+item.product.coverFile.key" v-if="item.product.coverFile">
                            </div>
                            <p class="red-font">{{item.chargeQuotePrice|currency('¥','2')}}</p>
                        </div>
                        <div class="right-info">
                            <p class="title">{{item.product.name}}</p>
                            <p>尺寸：{{item.product.specs[0].size}}</p>
                            <p>材质：{{item.product.specs[0].material}}</p>
                            <p v-if="item.fabric">
                                面料:
                                <span>{{item.fabric}}</span>
                            </p>
                            <p v-if="item.type === 0">备注:{{item.product.remark || '暂无备注'}}</p>
                        </div>
                    </div>
                    <p class="footer">
                        <span class="quoted-time">报价时间：{{item.statusChangeTime|setTimeDate}} &nbsp;&nbsp;&nbsp; {{item.statusChangeTime|setTime}}</span>
                        <button class="green-btn" @click="reduction([item.detailedListItemId])">还原</button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import api from "../../../api";
export default {
    data() {
        return {
            historyList: [{}],
            imgBaseUrl: api.common.imgBaseUrl
        };
    },
    methods: {
        gotoPrev() {
            this.$router.go(-1);
        },
        getHistoryList() {
            api.detailedLists
                .getHistoryQuotedList(this.$route.params.id)
                .then(res => {
                    this.historyList = res;
                });
        },
        reductionAll() {
            let detailedListItemIds = this.historyList.map(item => {
                return item.detailedListItemId;
            });
            this.reduction(detailedListItemIds);
        },
        reduction(detailedListItemIds) {
            api.detailedLists
                .reductionHistory(this.$route.params.id, {
                    detailedListItemIds: detailedListItemIds
                })
                .then(() => {
                    this.$Message.success("还原成功");
                    this.$router.go(-1);
                    this.getHistoryList();
                });
        }
    },
    created() {
        this.getHistoryList();
    }
};
</script>
<style scoped>
.content {
    width: 1200px;
    margin: 0 auto;
    height: 32px;
    line-height: 32px;
}
.content .text-btn {
    float: right;
    vertical-align: middle;
}
.content .text-btn:hover {
    text-decoration: underline;
}
.content .gotoPrev {
    float: left;
    width: 32px;
    height: 32px;
    background: #f4d03c;
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    font-size: 18px;
    vertical-align: middle;
    cursor: pointer;
}
.card-list {
    margin: 20px -10px 0 -10px;
}
.content .item {
    width: 590px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dce0e0;
    margin: 10px;
    padding: 20px;
    float: left;
    margin-top: -12px;
}
.content .item > div {
    overflow: hidden;
}
.content .item .left-info {
    float: left;
    width: 98px;
    margin-right: 10px;
}
.content .item .left-info .product-img {
    width: 98px;
    height: 98px;
    line-height: 98px;
    background: #f2f4f5;
    border-radius: 4px;
    margin-bottom: 4px;
}
.content .item .left-info .product-img img {
    vertical-align: middle;
}
.content .item .left-info p {
    font-size: 18px;
}
.content .item .right-info {
    float: left;
    width: 370px;
}

.content .item .right-info p {
    color: #6c6f70;
    margin-bottom: 2px;
    height: 19px;
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.content .item .right-info p.title {
    font-size: 18px;
    margin-bottom: 25px;
    color: #353838;
}
.footer {
    line-height: 26px;
}
.footer .quoted-time {
    color: #a2a2a8;
}
.footer button {
    height: 26px;
    line-height: 26px;
    font-size: 12px;
    border-radius: 4px;
    width: 60px;
    float: right;
}
.detailed-list .header-title {
    padding-bottom: 0;
}
.detailed-list .header-title .name-input {
    float: none;
    font-size: 24px;
    color: #308697;
}
</style>